module.exports = __webpack_public_path__ + "img/map01.f33e43f8.png";